import { Paper, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";

interface DisplaySettingsTableProps {
  enableEDSA: boolean;
  onChangeEDSASetting: (toggle: boolean) => void;
}

export const EDSASettings = ({ enableEDSA, onChangeEDSASetting }: DisplaySettingsTableProps) => {
  const { t } = useTranslation();
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <TableCell>
              <Switch checked={enableEDSA} onChange={() => onChangeEDSASetting(!enableEDSA)} />
            </TableCell>
            <TableCell>
              <Typography variant="h4">{t("displaySettings.edsaSettings.title")}</Typography>
              <Typography>
                <Trans
                  i18nKey="displaySettings.edsaSettings.description"
                  components={{ a: <a /> }}
                />
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody></TableBody>
      </Table>
    </TableContainer>
  );
};
